exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer{background-color:#cbced5}footer .footer-container{padding:0 50px;font-size:15px;color:#2e267c}footer .footer-container .brand__name{font-size:16px;font-weight:600;text-transform:uppercase;padding-top:30px;margin-bottom:10px}footer .footer-container .brand__address{margin-bottom:10px}footer .footer-container .brand__address p{margin:2px 0}footer .footer-container .brand__address p a{text-decoration:underline;color:#2e267c}footer .footer-container .brand__menu{border-bottom:1px solid #ffffff}footer .footer-container .brand__menu ul li{display:inline-table;margin:0 5px;padding:5px 20px}footer .footer-container .brand__menu ul li a{color:#ffffff;font-weight:600;text-transform:uppercase}footer .footer-container .brand__copyright{font-size:14px;font-weight:600;padding:4px 0}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/common/Footer.style.scss
// module id = 601
// module chunks = 0